/* import __COLOCATED_TEMPLATE__ from './attribute-select-item.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import templateOnly from '@ember/component/template-only';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';
import type ExternalFieldIdentifier from 'embercom/models/standalone/external-field-identifier';
import { type TicketField } from 'embercom/objects/standalone/data-fields/zendesk-ticket-field';
import type Attribute from 'embercom/models/attribute';

interface Args {
  item: {
    text: string;
    icon: InterfaceIconName;
    attribute: Attribute;
    standaloneField?: ExternalFieldIdentifier | TicketField;
    tooltipText?: string;
    onSelectItem: () => void;
    isSelected: boolean;
    disableStandaloneTooltip?: boolean;
  };
}

const AttributeSelectItem = templateOnly<Args>();

export default AttributeSelectItem;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Common::Attributes::AttributeSelectItem': typeof AttributeSelectItem;
    'standalone/common/attributes/attribute-select-item': typeof AttributeSelectItem;
  }
}
